import React from 'react';
import {usePath} from 'hooks/common';

export const BACK_TO_OFFER_LIST = 'backToOfferList';

export type OfferViewOrigin = 'list' | 'requests';

type Props = {
  backTo?: OfferViewOrigin;
};

export const usePathToOfferView = ({backTo}: Props = {}) => {
  const {getFullPath} = usePath();
  const getFullPathToOfferView = React.useCallback(
    (id: string) =>
      getFullPath(
        `recommendations/${id}${backTo ? `?${BACK_TO_OFFER_LIST}=${backTo}` : ''}`,
      ),
    [getFullPath, backTo],
  );
  return {getFullPathToOfferView};
};
